export default {
  drawer: null,
  color: 'accent',
}
